import { render, staticRenderFns } from "./HeadOfficeAccountInfo.vue?vue&type=template&id=3c135e99&scoped=true&"
import script from "./HeadOfficeAccountInfo.vue?vue&type=script&lang=js&"
export * from "./HeadOfficeAccountInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeadOfficeAccountInfo.vue?vue&type=style&index=0&id=3c135e99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c135e99",
  null
  
)

export default component.exports